export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/data": [7],
		"/demo": [8,[2]],
		"/demo/emoji-carousel": [9,[2]],
		"/demo/emoji-carousel/grid": [10,[2]],
		"/design/dpo": [11,[3]],
		"/design/features/1": [12,[3,4]],
		"/design/features/2": [13,[3,4]],
		"/design/features/3": [14,[3,4]],
		"/design/features/4": [15,[3,4]],
		"/design/gen-comments": [16,[3]],
		"/design/right": [17,[3]],
		"/design/sft": [18,[3]],
		"/slides": [19,[5]],
		"/slides/charts/number": [20,[5]],
		"/slides/charts/pie": [21,[5]],
		"/slides/charts/timeline": [22,[5]],
		"/slides/data/events": [23,[5]],
		"/slides/data/glossary": [24,[5]],
		"/slides/events": [25,[5]],
		"/slides/events/douyin": [26,[5]],
		"/slides/events/weibo": [27,[5]],
		"/slides/events/xiaohongshu": [28,[5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';